import { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { API, unwrap } from "./projetsCommon";

const byName = (key) => (a, b) => (a[key] || "").localeCompare(b[key] || "");

/** Charge les listes Clients et Employés actifs pour les menus déroulants. */
const useReferentiels = () => {
    const [clients, setClients] = useState([]);
    const [employes, setEmployes] = useState([]);

    useEffect(() => {
        axiosInstance.get(API.clients)
            .then((res) => setClients((unwrap(res) || []).slice().sort(byName("name"))))
            .catch(() => setClients([]));
        axiosInstance.get(`${API.employes}?actif=true`)
            .then((res) => setEmployes((unwrap(res) || []).slice().sort(byName("nomComplet"))))
            .catch(() => setEmployes([]));
    }, []);

    return { clients, employes };
};

export default useReferentiels;
